import React from "react";
import { Box } from "@chakra-ui/react";
import parse from "html-react-parser";

const WidgetStep = ({ step }) => {
  if (!step) return null;

  return (
    <Box className="tiptap-content" color="gray.700" mb={4}>
      {step.content ? parse(step.content) : "No content provided for this step."}
    </Box>
  );
};

export default WidgetStep;